import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import ChatSidebar from './ChatSidebar';
import ChatHeader from './ChatHeader';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

/** Ниже этого — мобильная вёрстка BananasGPT: сайдбар сворачивается */
const MOBILE_MAX_WIDTH = 768;

const clamp = (n, lo, hi, fallback) => {
    const v = Number(n);
    if (!Number.isFinite(v)) return fallback;
    return Math.min(hi, Math.max(lo, v));
};

const ChatShell = observer(({ children }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const s = chatStore.settings;
    const msgFont = clamp(s.message_font_size, 12, 24, 15);
    const listFont = clamp(s.chat_list_font_size, 11, 20, 14);
    const btnScale = clamp(s.button_scale, 0.75, 1.5, 1);
    const imgPreview = clamp(s.image_preview_size, 200, 960, 480);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
        const apply = () => {
            // на узком экране всегда сворачиваем; на широком не форсируем разворот
            if (mq.matches) {
                if (chatStore.sidebarPinned) chatStore.setSidebarPinned(false);
                chatStore.setSidebarCollapsed(true);
            }
        };
        apply();
        if (mq.addEventListener) {
            mq.addEventListener('change', apply);
            return () => mq.removeEventListener('change', apply);
        }
        mq.addListener(apply);
        return () => mq.removeListener(apply);
    }, []);

    return (
        <div
            className={`bananas-gpt-shell flex h-full w-full overflow-hidden ${
                isDark ? 'bg-[#212121] text-gray-100' : 'bg-[#f7f7f8] text-gray-900'
            }`}
            data-theme={isDark ? 'dark' : 'light'}
            style={{
                '--gpt-msg-font': `${msgFont}px`,
                '--gpt-list-font': `${listFont}px`,
                '--gpt-btn-scale': String(btnScale),
                '--gpt-img-preview': `${imgPreview}px`,
                // кнопки на превью пропорциональны размеру превью (база 480px)
                '--gpt-img-btn-scale': String(
                    Math.round((imgPreview / 480) * 100) / 100
                ),
            }}
        >
            <ChatSidebar />
            <div className="flex min-w-0 flex-1 flex-col">
                <ChatHeader />
                <div className="relative flex min-h-0 flex-1 flex-col">{children}</div>
            </div>
        </div>
    );
});

export default ChatShell;
